import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store'
import { INVOICE_FEATURE_KEY, InvoiceState, RootState } from './invoice.reducer'
import * as fromInvoice from './invoice.reducer'

export const reducers: ActionReducerMap<RootState> = {
  invoice: fromInvoice.invoiceReducer,
}

export const getInvoiceState = createFeatureSelector<InvoiceState>(INVOICE_FEATURE_KEY)

export const getInvoice = createSelector(getInvoiceState, (state: InvoiceState) => state)

export const getHasUnpaidInvoice = createSelector(getInvoice, (invoice: InvoiceState) => {
  return !!(invoice && invoice.total && !invoice.paid)
})

export const getInvoiceLineItems = createSelector(getInvoiceState, (state: InvoiceState) => state.line_items)

export const getInvoiceLoaded = createSelector(getInvoiceState, (state) => state.loaded)

export const isEmptyInvoice = createSelector(
  getInvoiceState,
  (state) => state.loaded && state.line_items && state.line_items.length === 0,
)
